// extracted by mini-css-extract-plugin
export var closeIcon = "NotificationsContext-module--closeIcon--8b16c";
export var notification = "NotificationsContext-module--notification--29bd6";
export var notificationContainer = "NotificationsContext-module--notificationContainer--f152e";
export var notificationIcon = "NotificationsContext-module--notificationIcon--68cfc";
export var textStyleLargeTitle = "NotificationsContext-module--text-style-large-title--8cf7b";
export var textStyleLargestTitle = "NotificationsContext-module--text-style-largest-title--d3155";
export var textStyleMediumTitle = "NotificationsContext-module--text-style-medium-title--b6726";
export var textStyleSmallTitle = "NotificationsContext-module--text-style-small-title--5339b";